import dayjs from 'dayjs';
import { useEffect, useRef } from 'react';
/**
 * Returns a function that, when called, calls all the functions
 * passed to it, applying its arguments to them.
 *
 * @param {Function[]} functions
 */
export var mergeFunctions = function mergeFunctions() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return functions.filter(Boolean).forEach(function (f) {
      return f.apply(void 0, args);
    });
  };
};

/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */
export var callIfDefined = function callIfDefined(fn) {
  if (fn && typeof fn === 'function') {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    fn.apply(void 0, args);
  }
};

/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */
export var between = function between(value, min, max) {
  if (min && min > value) {
    return min;
  }
  if (max && max < value) {
    return max;
  }
  return value;
};
export var datesAreDifferent = function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
};
export var ALL_VIEWS = ['decade', 'year', 'month'];
var allValueTypes = [].concat(ALL_VIEWS.slice(1), ['day']);
export var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
  return ALL_VIEWS.slice(ALL_VIEWS.indexOf(minDetail), ALL_VIEWS.indexOf(maxDetail) + 1);
};

/**
 * Returns value type that can be returned with currently applied settings.
 */

export var getValueType = function getValueType(maxDetail) {
  return allValueTypes[ALL_VIEWS.indexOf(maxDetail)];
};
export var getValueFrom = function getValueFrom(value) {
  if (!value || value.length === 0) {
    return null;
  }
  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;
  if (!rawValueFrom) {
    return null;
  }
  var valueFromDate = new Date(rawValueFrom);
  if (isNaN(valueFromDate.getTime())) {
    return null;
  }
  return valueFromDate;
};
export var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail, momentUtils) {
  var valueFrom = getValueFrom(value);
  if (!valueFrom) {
    return null;
  }
  var detailValueFrom = momentUtils.getStartDate(valueFrom, getValueType(maxDetail));
  return between(detailValueFrom, minDate, maxDate);
};
export var getValueTo = function getValueTo(value) {
  if (!value || value.length === 0) {
    return null;
  }
  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;
  if (!rawValueTo) {
    return null;
  }
  var valueToDate = new Date(rawValueTo);
  if (isNaN(valueToDate.getTime())) {
    return null;
  }
  return valueToDate;
};
export var getStartAndEndDateOfView = function getStartAndEndDateOfView(view, startDate) {
  var _startDate = startDate;
  var _endDate = null;
  if (view === 'month') {
    var midDate = dayjs(_startDate).add(15, 'day');
    _startDate = midDate.startOf('month').toDate();
    _endDate = midDate.endOf('month').toDate();
  } else if (view === 'year') {
    _endDate = dayjs(_startDate).add(11, 'month').toDate();
  } else if (view === 'decade') {
    _endDate = dayjs(_startDate).add(11, 'year').toDate();
  }
  return [_startDate, _endDate];
};
export var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
};